import React from 'react';
import { aboutPreviewData } from '../data/mock';
import { Target, Users, MessageCircle, Zap } from 'lucide-react';

const iconMap = {
  Target,
  Users,
  MessageCircle,
  Zap
};

const WhyChooseUs = () => {
  return (
    <section className="py-24 bg-purple-100/60 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#6b2d7b] mb-4">
            {aboutPreviewData.title}
          </h2>
          <p className="text-xl text-slate-600">
            {aboutPreviewData.subtitle}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {aboutPreviewData.features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={index}
                className="group p-8 rounded-2xl bg-slate-50 hover:bg-[#6b2d7b] transition-all duration-300 hover:shadow-lg hover:shadow-[#6b2d7b]/20 hover:-translate-y-1"
              >
                <div className="w-14 h-14 rounded-xl bg-[#7ed321]/20 flex items-center justify-center mb-6 group-hover:bg-[#7ed321] transition-colors duration-300">
                  <IconComponent className="w-7 h-7 text-[#6b2d7b] group-hover:text-[#2d1b38] transition-colors duration-300" />
                </div>
                <h3 className="text-xl font-semibold text-slate-900 mb-3 group-hover:text-white transition-colors duration-300">
                  {feature.title}
                </h3>
                <p className="text-slate-600 leading-relaxed group-hover:text-white/80 transition-colors duration-300">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
